import React from 'react';
import { styles, styleVars } from './LaunchTiles.css';
import { palette } from '@jbhi-fi/lanyard-ui/themes';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import { ContentThemePalette } from '../Contentful/transformers/ThemeTransformer';

export type LaunchTilesProps = {
  tiles: Array<LaunchTileProps>;
};

export type LaunchTileProps = {
  label: string;
  icon: React.ReactElement;
  url: string;
  shouldOpenInNewWindow?: boolean;
  id?: string;
  hoverPalette?: ContentThemePalette;
};

export const LaunchTile = ({ icon, label, url, shouldOpenInNewWindow = false, id, hoverPalette }: LaunchTileProps) => (
  <a
    href={url}
    className={styles.tile}
    style={assignInlineVars({
      [styleVars.hoverTextColor]: hoverPalette?.text ?? palette.primary.dark,
      [styleVars.hoverBackgroundColor]: hoverPalette?.background ?? palette.primary.main,
    })}
    id={id}
    {...(shouldOpenInNewWindow ? { target: '_blank', rel: 'noreferrer' } : {})}
  >
    {icon ?? null}
    <span className={styles.label}>{label}</span>
  </a>
);

export const LaunchTiles = ({ tiles }: LaunchTilesProps) => {
  return (
    <div className={styles.container}>
      {tiles.map((tile, i) => (
        <LaunchTile key={i} {...tile} />
      ))}
    </div>
  );
};
